module.exports = __webpack_public_path__ + "images/emoji/microscope.92958fcc4bc64ba9e958.png";